const CalendarToolbar = require("./calendar-toolbar");
const CalendarLegend = require("./calendar-legend");
const ColorSchemes = require("./calendar-color-schemes");
const MetricType = require("../Metric/metric-type");
const UserPreferences = require("app/util/browser/user-preferences");

const CalendarWrapper = React.createClass({
  componentWillMount: function() {
    const savedColorSchemeName = UserPreferences.calendarColorScheme.get()
    this.colorScheme = ColorSchemes.find(colorScheme => colorScheme.name === savedColorSchemeName) || ColorSchemes[0]
    this.defaultView = "month";
  },

  componentDidMount: function() {
    CUI.init({
      container: '#calendar',
      events: CUI.events.get,
      eventClick: CUI.event.handleClick,
      eventDrop: CUI.event.handleDrop,
      loading: CUI.loader.toggle,
      dayRender: CUI.days.handleRender,
      dayClick: CUI.day.handleClick,
      eventRender: this.onActivityRender,
      defaultView: this.defaultView,
      aspectRatio: 2.1,
      header: { left: '', center: 'title', right: '' },
      eventTextColor: 'white',
      eventStartEditable: true,
      eventDurationEditable: false,
      allDayDefault: true,
      allDayText: 'Dia todo',
      views: {
        month: {
          titleFormat: "MMMM [de] YYYY",
          timeFormat: "HH:mm"
        }
      },
      scrollTime: '00:00:00',
      defaultTimedEventDuration: '00:30:00',
      slotEventOverlap: true,
      themeSystem: 'bootstrap3',
      bootstrapGlyphicons: {
        close: ' custom-glyphicon icon-close',
      },
      eventLimit: 4
    });
  },

  updateColorScheme: function(colorScheme) {
    this.colorScheme = colorScheme;
    UserPreferences.calendarColorScheme.set(colorScheme.name);
    this.action("rerenderEvents");
  },

  reloadActivities: function() {
    this.action("refetchEvents");
  },

  changeView: function(viewName) {
    this.action("changeView", viewName);
  },

  toggleEditing: function(value) {
    this.action("option", { eventStartEditable: value });
  },

  action: function(name, arg) {
    $(this.refs.calendar).fullCalendar(name, arg);
  },

  onActivityRender: function(activity, element) {
    const color = this.colorScheme.colorFor(activity);
    let css = { backgroundColor: color, borderColor: color };

    // If activity was explicitly made not startEditable
    if (activity.startEditable === false) css.opacity = 0.5;

    element.css(css);

    if (activity.metric) {
      element.find(".fc-content").prepend(this.renderIcon(activity));
    }
  },

  renderIcon: function(activity) {
    const url = MetricType.getImageUrl(activity.metric.toUpperCase(), "-muted");
    return (`<img class="icon" src="${url}" />`);
  },

  render: function() {
    return (
      <div>
        <CalendarToolbar
          changeView={this.changeView}
          navigateView={this.action}
          reloadActivities={this.reloadActivities}
          toggleEditing={this.toggleEditing}
          availableViews={[
            { name: "month", label: "Mês" },
            { name: "agendaWeek", label: "Semana" },
            { name: "agendaDay", label: "Dia" }
          ]}
          view={this.defaultView}
        />
        <div id="calendar" ref="calendar" />
        <CalendarLegend
          colorScheme={this.colorScheme}
          updateColorScheme={this.updateColorScheme}
        />
      </div>
    );
  }
});

module.exports = CalendarWrapper;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/Calendar/calendar-wrapper.jsx